import { condition } from "context/condition";
import { Globalstate } from "context/context";
import useLikeDislike from "hooks/useLikeDislike";
import React, { useState } from "react";
import { AiOutlineDislike, AiOutlineLike } from "react-icons/ai";

const LikeDislike = ({
  answer_type,
  responseId,
  isBingResponse,
  query,
  msgLikeDislike,
  isLastMessage,
  messageKey,
  nudgeFlag,
  sources
}) => {
  const [toggleLikeDislike, setToggleLikeDislike] = useState(0);
  const { mutateAsync } = useLikeDislike();
  const { state, dispatch } = Globalstate();
  const handleLike = (e) => {
    e.stopPropagation();
    setToggleLikeDislike(1);
    mutateAsync({
      type: "like",
      answer_type,
      id: responseId,
      // source: state?.source
      sources:
        sources === "fetch_nudge"
          ? "nudge"
          : sources == undefined
            ? "nudge_qna"
            : state?.source
    });

  };
  const handleDislike = (e) => {
    e.stopPropagation();
    setToggleLikeDislike(2);
    mutateAsync({
      type: "dislike",
      answer_type,
      id: responseId,
      sources:
        sources === "fetch_nudge"
          ? "nudge"
          : sources == undefined
            ? "nudge_qna"
            : state?.source
    });


    if (msgLikeDislike && !isBingResponse && isLastMessage && !nudgeFlag) {
      dispatch({
        type: condition.UPDATEMESSGES,
        payload: {
          key: messageKey,
          data: { unavailability_flag: true }
        }
      });
    }
  };

  return (
    <div className="like-dislike">
      <div
        className={`chat-like ${toggleLikeDislike === 1 && "like-toggled"}`}
        onClick={handleLike}
      >
        <AiOutlineLike />
      </div>
      <div
        className={`chat-dislike ${toggleLikeDislike === 2 && "like-toggled"}`}
        onClick={handleDislike}
      >
        <AiOutlineDislike />
      </div>
    </div>
  );
};

export default LikeDislike;
